import React, { PureComponent } from "react";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { compose } from "redux";
import { withTranslation } from "react-i18next";

import styles from './style.css';
import { SignInEmailErrorCodeEnum } from "../../../domain/enums/SignInEmailErrorEnum";
import { abeEmailSelector, abeFormErrorsSelector, resetEmailSendedSelector } from "../../../store/auth-by-email/selectors";
import { resetPassword, setEmail, setFormErrors, setPassword, donePasswordReset } from "../../../store/auth-by-email/actions";
import UQFormErrors from "../../../../uq-forms/components/form-errors";
import UQFormsTextField from "../../../../uq-forms/components/text-field";
import UQButton from "../../../../uq-ui/components/button";
import { currentUserInfoSelector } from "../../../store/auth-user/selectors";
import LayoutComponentsHeader from "../../../../layout/ui/components/header";
import Div100vh from "../../../../uq-ui/components/div-100";
import { createErrorExtractor } from "../../../../uq-forms/helpers";

const GreetingImage = require('./researcher.svg');

const errorExtractor = createErrorExtractor({
  email: {
    [SignInEmailErrorCodeEnum.InvalidEmail]: 'errors.invalidEmail',
  },
  form: {
    [SignInEmailErrorCodeEnum.UserNotFound]: 'errors.accountNotFound',
  }
});

class AuthScreensLogin extends PureComponent {
  onBack = () => {
    if (this.props.haveSent) { this.props.donePasswordReset(); }
    else { this.props.history.replace('/login/email'); }
  };

  componentDidMount() {
    this.props.resetFormErrors();
  }

  onDonePress = () => {
    this.props.donePasswordReset();
    this.props.history.replace('/login/email');
  }

  renderDone() {
    const message = this.props.t('doneMessage').replace('<email>', `'${this.props.email}'`);
    return (
      <div>
        <div className={`${styles.doneMessage} font-text`}>{message}</div>
        <UQButton label={this.props.t('done')}
                  onPress={this.onDonePress}
                  containerClass={styles.doneBtnWrap}
                  innerClass={styles.submitBtn}/>
      </div>
    );
  }

  renderEmailInput() {
    return (
      <div>
        <div className={styles.formContainer}>
          <div className={styles.form}>
            { this.props.formErrors.form && (
              <UQFormErrors
                textStyle={{ textAlign: 'center' }}
                error={errorExtractor.get('form', this.props.formErrors, this.props.t)} />
            ) }
            <UQFormsTextField
              label={this.props.t('email')}
              type="email"
              labelClassName="font-text"
              autoCapitalize="none"
              value={this.props.email}
              error={errorExtractor.get('email', this.props.formErrors, this.props.t)}
              onChange={(event) => this.props.onChangeEmail(event.target.value)}
            />
          </div>
        </div>
        <div className={styles.buttonsContainer}>
          <Link to="/login/email" className={`${styles.cancelLink} font-text`}>{this.props.t('cancel')}</Link>
          <UQButton label={this.props.t('reset')}
                    onPress={this.props.resetPassword}
                    containerClass={styles.submitBtnWrap}
                    innerClass={styles.submitBtn}/>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Div100vh className={styles.container}>
        <LayoutComponentsHeader showBackBtn={true} 
                                onBack={this.onBack}
                                showLogo={true} />
        <div className={styles.innerTop}>
          <div className={`${styles.authTogglerLinkActive} font-title`}>{this.props.t('forgotPassword')}</div>
          { !this.props.haveSent && this.renderEmailInput() }
          { this.props.haveSent && this.renderDone() }
        </div>
        <div className={styles.innerBottom}>
          <img src={GreetingImage} className={styles.greeting} />
        </div>
      </Div100vh>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    email: abeEmailSelector(state),
    formErrors: abeFormErrorsSelector(state),
    haveSent: resetEmailSendedSelector(state),
    currentUserInfo: currentUserInfoSelector(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeEmail: (value) => dispatch(setEmail(value)),
    resetFormErrors: () => dispatch(setFormErrors({})),
    resetPassword: () => dispatch(resetPassword()),
    donePasswordReset: () => dispatch(donePasswordReset())
  }
};

export default compose(
  withTranslation('scr-forgot-password'),
  connect(mapStateToProps, mapDispatchToProps)
)(AuthScreensLogin);